import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CompanySelectionComponent} from './company-selection.component';
import {ContentLoadingIndicatorModule} from '@app/shared/content-loading-indicator/content-loading-indicator.module';
import {AuthGuard, ConfigModule, I18nModule} from '@spartacus/core';
import {NavigationToModule} from '@app/shared/navigation-to/navigation-to.module';
import {
  ComboBoxDropdownModule,
  ComboBoxModule,
  CountrySelectorModule,
  InputModule,
  TextSearchHighlightModule
} from 'ng-design-system';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CompanyAddressSelectionComponent} from '../company-address-selection/company-address-selection.component';
import {DisposableMessageModule} from '@app/shared/disposable-message/disposable-message.module';
import {UserRegistrationDoneGuard} from '@app/checkout/guards/user-registration-done.guard';
import {CompanyNewAddressComponent} from '../company-new-address/company-new-address.component';
import {
  GenericConfiguratorErrorModule
} from '@app/product/configurator/error-handling/generic-configurator-error/generic-configurator-error.module';
import {NetNewModule} from '@app/product/configurator/error-handling/net-new/net-new.module';
import {ContactUsButtonModule, ContactUsLinkModule, LoadingPageModule} from '@dcp/configurator';

@NgModule({
  declarations: [
    CompanySelectionComponent,
    CompanyAddressSelectionComponent,
    CompanyNewAddressComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CompanySelectionComponent: {
          component: CompanySelectionComponent,
          guards: [
            AuthGuard,
            UserRegistrationDoneGuard
          ]
        }
      }
    }),
    ContentLoadingIndicatorModule,
    I18nModule,
    NavigationToModule,
    ComboBoxDropdownModule,
    FormsModule,
    TextSearchHighlightModule,
    RouterModule,
    DisposableMessageModule,
    InputModule,
    ReactiveFormsModule,
    ComboBoxModule,
    CountrySelectorModule,
    GenericConfiguratorErrorModule,
    NetNewModule,
    LoadingPageModule,
    ContactUsButtonModule,
    ContactUsLinkModule,
  ],
  exports: [CompanySelectionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CompanySelectionModule {
}
